import { useLazyQuery } from "@apollo/client";
import React, { useEffect, useState, useMemo, useRef } from "react";
import { clientWellness } from "../../App";
import GeneralFiltersComponent from "../../components/GeneralFiltersComponent/GeneralFiltersComponent";
import {
  ALL_CATEGORIES,
  ALL_LANGUAGES,
  ALL_SPEAKERS,
  COUNTRIES_BY_CLIENT,
  GET_EVENT_STATUS,
} from "../../GraphQL/Queries";
import { getStateLoginComplete } from "../LayoutHome/stateLogin";
import PropTypes from 'prop-types';

const GeneralFiltersContainer = ({
  filtered,
  filtersViews,
  FilterEvents,
  setDataFilter,
  setFiltered,
  showTopHR,
}) => {
  const userComplete = useMemo(() => getStateLoginComplete(), []);
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState();
  const [languages, setLanguages] = useState();
  const [speakers, setSpeakers] = useState();
  const [eventCategories, setEventCategories] = useState();
  const [eventStatus, setEventStatus] = useState();
  const rCities = useRef();

  const [runQueryLanguages] = useLazyQuery(ALL_LANGUAGES, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: ({ allLanguages }) => {
      const resultOfLanguages = allLanguages?.nodes?.map((element) => ({
        value: element?.id,
        label: element?.name,
      }));
      setLanguages(resultOfLanguages);
    },
    onError: (error) => {
      console.error("Error fetching languages:", error);
      // Puedes agregar lógica de manejo de errores aquí
    },
  });

  const [runQuerySpeakers] = useLazyQuery(ALL_SPEAKERS, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: ({ allSpeakers }) => {
      const resultOfSpeakers = allSpeakers?.map((element) => ({
        value: element?.id,
        label: element?.name,
      }));
      setSpeakers(resultOfSpeakers);
    },
    onError: (error) => {
      console.error("Error fetching speakers:", error);
    },
  });

  const [runQueryCategories] = useLazyQuery(ALL_CATEGORIES, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: ({ allCategories }) => {
      const resultOfAllCategories = allCategories?.map((element) => ({
        value: element?.idCategory,
        label: element?.categoryName,
      }));
      setEventCategories(resultOfAllCategories);
    },
    onError: (error) => {
      console.error("Error fetching categories:", error);
    },
  });

  const [runQueryEventStatus] = useLazyQuery(GET_EVENT_STATUS, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: ({ allAttendStatus }) => {
      const resultOfEventStatus = allAttendStatus
        .filter((f) => f.description !== "Tentative")
        .map((element) => ({
          value: element?.description,
          label: element?.description,
        }));
      setEventStatus(resultOfEventStatus);
    },
    onError: (error) => {
      console.error("Error fetching event status:", error);
    },
  });

  const [runQueryCountry] = useLazyQuery(COUNTRIES_BY_CLIENT, {
    fetchPolicy: "network-only",
    onCompleted: ({ countryLocationList }) => {
      const resultOfCountries = countryLocationList?.map((element) => ({
        ...element,
        value: element?.countryId,
        label: element?.countryName,
      }));
      setCountries(resultOfCountries);
    },
    onError: (error) => {
      console.error("Error fetching countries:", error);
    },
  });

  const getCityForCountry = (id) => {
    const selectedCountry = countries.filter((e) => e.countryId === parseInt(id));
    if (selectedCountry?.length > 0) {
      const citiesArr = selectedCountry[0].cities.map((e) => ({
        ...e,
        value: e.cityId,
        label: e.cityName,
      }));
      setCities(citiesArr);
    } else {
      setCities([]);
    }
  };

  const handleChangeSelectCountry = (item) => {
    setCities([]);
    rCities.current.clearValue();
    if (item?.value) {
      getCityForCountry(item.value);
    }
  };

  const handleCleanFilters = () => {
    setCities([]);
    setDataFilter({});
    setFiltered(false);
  };

  useEffect(() => {
    if (!filtered) {
      FilterEvents();
    }
  }, [filtered]);

  useEffect(() => {
    runQueryLanguages({ variables: { first: 25 } });
    runQuerySpeakers();
    runQueryCategories();
    runQueryCountry({
      variables: { clientId: userComplete.clientId },
      context: { clientName: "LinkUsers" },
    });
    runQueryEventStatus();
  }, [userComplete]);

  return (
    <GeneralFiltersComponent
      languages={languages}
      speakers={speakers}
      eventCategories={eventCategories}
      countries={countries}
      cities={cities}
      eventStatus={eventStatus}
      setDataFilter={setDataFilter}
      handleChangeSelectCountry={handleChangeSelectCountry}
      handleCleanFilters={handleCleanFilters}
      FilterEvents={FilterEvents}
      filtersViews={filtersViews}
      showTopHR={showTopHR}
      rCities={rCities}
    />
  );
};

GeneralFiltersContainer.propTypes = {
  filtered: PropTypes.bool,
  filtersViews: PropTypes.object, // Puedes ajustar el tipo según la estructura real de filtersViews
  FilterEvents: PropTypes.func,
  setDataFilter: PropTypes.func,
  setFiltered: PropTypes.func,
  showTopHR: PropTypes.bool,
};

export default GeneralFiltersContainer;
